import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { CoronaComponent } from './pages/corona/corona.component';
import { AdminComponent } from './pages/admin/admin.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CustomerComponent } from './pages/customer/customer.component';
import { TeamsComponent } from './pages/teams/teams.component';
import { TranslateModule } from '@ngx-translate/core';
import { MissingPermissionComponent } from './app.missing-auth.component';
import { LoginNotPossibleComponent } from '@app/pages/login-not-possible/login-not-possible';

const routes: VexRoutes = [
	{
		path: '',
		component: CustomLayoutComponent,
		children: [
			{
				path: 'missing-permissions',
				component: MissingPermissionComponent,
			},
			/*{
				path: '',
				loadChildren: () => import('./utilities/authentication/authentication.module').then(m => m.AuthenticationModule),
			},
			{
				path: 'login',
				loadChildren: () => import('./utilities/authentication/authentication.module').then(m => m.AuthenticationModule),
			},*/
			{
				path: '',
				redirectTo: 'home',
				pathMatch: 'full'
			},
			{
				path: 'home',
				component: DashboardComponent,
			},
			{
				path: 'corona',
				component: CoronaComponent,
			},
			{
				path: 'profile',
				loadChildren: () => import('./pages/profile/profile.module').then(mod => mod.ProfileModule),
			},
			{
				path: 'projects',
				loadChildren: () => import('./pages/projects/projects.module').then(mod => mod.ProjectsModule),
				// data: { canLoadPermission: '/projects/view' },
			},
			{
				path: 'family',
				loadChildren: () => import('./pages/employees/employee.module').then(mod => mod.EmployeeModule),
			},
			{
				path: 'customers',
				component: CustomerComponent,
			},
			{
				path: 'teams',
				component: TeamsComponent,
			},
			{
				path: 'admin',
				component: AdminComponent,
			},
			{
				path: 'events',
				loadChildren: () => import('./pages/events/events.module').then(mod => mod.EventsModule),
			},
			{
				path: 'list-of-links',
				loadChildren: () => import('./pages/list-of-links/list-of-links.module').then(mod => mod.ListOfLinksModule),
			},
			{
				path: 'process-manual',
				loadChildren: () => import('./pages/process-manual/process-manual.module').then(mod => mod.ProcessManualModule),
			},
			{
				path: 'meetups',
				loadChildren: () => import('./pages/meetups/meetups.module').then(mod => mod.MeetupsModule),
			},
			{
				path: 'skills',
				loadChildren: () => import('./pages/skills/skills.module').then(mod => mod.SkillsModule),
			},
			{
				path: 'todos',
				loadChildren: () => import('./pages/todo/todo.module').then(mod => mod.TodoModule),
			},
			{
				path: 'r18',
				loadChildren: () => import('./pages/r18/r18.module').then(mod => mod.R18Module),
			},
			{
				path: 'teamcalendar',
				loadChildren: () => import('./pages/teamcalendar/teamcalendar.module').then(mod => mod.TeamCalendarModule),
			},
			{
				path: 'karma',
				loadChildren: () => import('./pages/karma-points/karma-points.module').then(mod => mod.KarmaPointsModule),
			},
			{
				path: 'ai',
				loadChildren: () => import('./pages/ai/ai.module').then(mod => mod.AiModule),
			},
		],
	},
	{
		path: 'login-not-possible',
		component: LoginNotPossibleComponent,
	},
	{ path: '**', redirectTo: 'home' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
	imports: [
		TranslateModule,
		RouterModule.forRoot(routes, {
			initialNavigation: !isIframe ? 'enabled' : 'disabled', // Don't perform initial navigation in iframes
			preloadingStrategy: QuicklinkStrategy,
			scrollPositionRestoration: 'enabled',
			relativeLinkResolution: 'corrected',
			anchorScrolling: 'enabled',
		}),
	],
	exports: [RouterModule, QuicklinkModule],
})
export class AppRoutingModule {}
